import { Link } from "react-router-dom";

const categoryLinks = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/drama" },
  { label: "综艺", to: "/category/variety" },
];

const topicLinks = [
  { label: "日韩经典电影重温计划", to: "/special/sp01" },
  { label: "高能悬疑追剧清单", to: "/special/sp02" },
  { label: "治愈系亚洲家庭剧", to: "/special/sp03" },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-primary-900 bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full grid-cols-2 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-movie-2-fill text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              亚洲一区二区在线
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-400">
            汇聚亚洲电影、电视剧与综艺节目，提供清晰的分类筛选与影视资讯，陪你发现下一部想看的作品。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">影视分类</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {categoryLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-background-400 transition-colors hover:text-accent-400"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">精选专题</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {topicLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="text-background-400 transition-colors hover:text-accent-400"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">关于与联系</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <Link
                to="/about"
                className="text-background-400 transition-colors hover:text-accent-400"
              >
                关于我们
              </Link>
            </li>
            <li className="flex items-center gap-2 text-background-400">
              <i className="ri-mail-line"></i>
              <span>service@yzyq2q-demo.com</span>
            </li>
            <li className="flex items-center gap-2 text-background-400">
              <i className="ri-time-line"></i>
              <span>每日 09:00 - 23:00</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-900/70">
        <div className="mx-auto flex w-full flex-col gap-3 px-4 py-6 text-xs text-background-500 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 亚洲一区二区在线 · 保留所有权利</p>
          <p>
            本站为演示站点，所有影视名称、评分及人物信息均为虚构，不提供真实播放服务。
          </p>
        </div>
      </div>
    </footer>
  );
}